import {
  addToCompareList,
  assignCompareList,
  createCompareList as createCompareListService,
  deleteCompareList,
  getCompareList as getCompareListService,
  removeItemFromCompareList,
} from '@/services'
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { useCommonStore } from './common'

interface TCompareState {
  compareUid: string
  compareList: IVariantsProduct[]
  count: number
}
interface TCompareAction {
  createCompareList: (data?: string[]) => Promise<IResponse<any> | undefined>
  getCompareList: () => void
  addToCompareList: (data: string) => Promise<IResponse<any>>
  removeFromCompareList: (data: string) => Promise<IResponse<any>>
  assignToUser: () => Promise<any>
  clearCompareList: () => void
}

type TCompareStore = TCompareState & TCompareAction

const initialCompare: TCompareState = {
  compareUid: '',
  compareList: [],
  count: 0,
}

export const useCompareStore = create<TCompareStore>()(
  devtools(
    persist(
      (set, get) => ({
        compareUid: initialCompare.compareUid,
        compareList: initialCompare.compareList,
        count: initialCompare.count,
        getCompareList: async () => {
          const response = await getCompareListService(get().compareUid)
          if (response?.data == null) return useCommonStore.getState().setNoti(response?.message, 'error')
          set((state) => ({
            ...state,
            compareList: response?.data?.items,
            count: response?.data?.item_count,
          }))
        },
        createCompareList: async (data) => {
          // if (!get().compareUid) return { status: 'info', message: 'Not found data' }
          const response = await createCompareListService(data ?? [])
          if (response?.data == null) return { status: 'error', message: response?.message }
          set((state) => {
            state.compareUid = response?.data?.uid
            return state
          })
          await get().getCompareList()
          if (data) return { status: 'success', message: 'Add item to compare-list successfully' }
        },
        addToCompareList: async (data) => {
          if (!data) return { status: 'info', message: 'Not found data' }
          const response = await addToCompareList({ compareUid: get().compareUid, listIdProducts: [data] })
          if (!response?.data) return { status: 'error', message: response?.message }
          set((state) => {
            if (response?.data?.item_count) state.count = response?.data?.item_count
            return state
          })
          await get().getCompareList()
          return { status: 'success', message: 'Add item to compare-list successfully' }
        },
        removeFromCompareList: async (data) => {
          if (!data) return { status: 'info', message: 'Not found data' }
          const response = await removeItemFromCompareList({
            compareUid: get().compareUid,
            listIdProducts: [data],
          })
          if (!response?.data) return { status: 'error', message: response?.message }
          set((state) => {
            if (response?.data?.item_count) state.count = response?.data?.item_count
            return state
          })
          await get().getCompareList()
          return { status: 'success', message: 'Remove item to compare-list successfully' }
        },
        assignToUser: async () => {
          if (!get().compareUid) return await get().createCompareList()
          const response = await assignCompareList(get().compareUid)
          if (response?.status == 'error')
            useCommonStore.getState().setNoti('Something went wrong when assigning compare list', 'error')
          await get().createCompareList()
        },
        deleteCompareList: async () => {
          const response = await deleteCompareList(get().compareUid)
          if (response?.status == 'error')
            useCommonStore.getState().setNoti('Something went wrong when deleting compare list', 'error')
        },
        clearCompareList: () => {
          set(() => ({ ...initialCompare }))
        },
      }),
      {
        name: 'compare-storage',
      }
    )
  )
)
